import React from "react";

export const InputDisableView = (props) => {
    const {width, height} = props

    const getWidth = (w) => {
        if (w) {
            return w
        }
        return "100%"
    }
    const getHeight = (h) => {
        if (h) {
            return h
        }
        return "55%"
    }
    return <input type='text' className='form-control' disabled={'disabled'}
                  style={{
                      position: 'absolute',
                      width: getWidth(width),
                      top: 32,
                      height: getHeight(height),
                      backgroundColor: 'rgba(233, 236, 239,0.4)'
                  }}/>;
}
